module.exports = __webpack_public_path__ + "static/media/consumer.ad25ce39.svg";